import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect, useRef, useCallback} from 'react';
import {connect} from 'react-redux';
import {renderAuthButtons, text} from '../../constants';
import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';
import useScrollBlock from '../../useScrollBlock';
import NavItem from './NavItems';
import SelfCareItem from './SelfCareItem';
import PurpleItem from './PurpleItem';
import TabSwitch from './TabSwitch';
import DisconnectUser from './DisconnectUser';
import {setIndex, toggleTabButton} from '../../HeaderBlockSlice';

const MainMenu = (props) => {
  const {
    headerData: {tabIndex, tabs, animate, navButtonsCurrent, navButtonsNew, selfCareData},
    showMenu,
    toggleVisibility,
  } = props;
  let menuRef = useRef();

  const getMenuIcon = () => {
    if (tabIndex && tabIndex >= 0 && tabs[tabIndex]?.isBusinessTab?.value) {
      return showMenu ? require('../../images/close-b-menu.svg') : require('../../images/menu-b-icon.svg');
    }
    return showMenu ? require('../../images/close-menu.svg') : require('../../images/menu-icon.svg');
  };

  return (
    <div>
      <div className='menu-img'>
        <Image src={getMenuIcon()} onClick={() => toggleVisibility(true)} alt={'menu'} />
      </div>
      {showMenu && (
        <div className={`${animate} side-bar`}>
          <div className='nav-items'>
            {navButtonsCurrent?.map((item, index) => (
              <NavItem
                key={index}
                props={props}
                item={item}
                index={index}
                toggleVisibility={toggleVisibility}
                buttonType='regularButtons'
              />
            ))}
            {navButtonsNew?.map((item, index) => (
              <NavItem key={index} props={props} item={item} index={index} toggleVisibility={toggleVisibility} buttonType='navButtonsNew' />
            ))}
          </div>
          {selfCareData?.regularButtons?.value && (
            <div className='nav-items-self-care'>
              <div className='self-care-title'>{text.selfCare}</div>
              <div className='self-care-items-regular'>
                {selfCareData?.regularButtons?.expandedValue.map((item, i) => (
                  <SelfCareItem key={i} context={props.context} headerData={props.headerData} item={item} i={i} />
                ))}
              </div>
            </div>
          )}
          {selfCareData?.purpleButtons?.value && (
            <div className='self-care-items-purple'>
              {selfCareData?.purpleButtons?.expandedValue.map((item, i) => (
                <PurpleItem key={i} context={props.context} item={item} i={i} />
              ))}
            </div>
          )}
          <DisconnectUser authentication={props.authentication} context={props.context} />
          <TabSwitch headerData={props.headerData} context={props.context} setShowMenu={props.setShowMenu} />
        </div>
      )}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    headerData: state.Header,
    authentication: state.authentication,
  };
};
const mapDispatchToProps = {
  setIndex,
  toggleTabButton,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);
